<template>
  <v-container class="main-container responsive-height">
    <AllClient></AllClient>
  </v-container>
</template>

<script>
import AllClient from '@/components/MyClients/Summary/AllClient.vue';

export default {
  components: {
    AllClient
  },
};
</script>
